import '../css/app.css';
import '../css/animate.min.css';
import '../css/all.min.css';
import '../css/fontawesome-all.min.css';
import '../css/fonts.css';
import '../css/boxes.css';
import '../css/plyr.css';
import '../css/solar.scss';

// Import de jQuery dans chaque fichier JS, y compris dans le main
import $ from "jquery";

// Charger le SDK SoundCloud lorsque le document est prêt
$(function() {
  loadSoundCloudSDK();
});

import Alpine from 'alpinejs';
window.Alpine = Alpine;
Alpine.start();

import './bootstrap';
import './vendor/pixi';
import './vendor/boxes';
import './vendor/astronomical';
import { loadSoundCloudSDK } from './vendor/soundcloud.js';

import.meta.glob([
  '../img/**',
  '../fonts/**',
]);

/**
 * Special keyboard shortcut handler
 */
(function() {
    const mk = [0x41, 0x44, 0x4D]; // Hex codes
    let kc = [];
    let kt = null;
    
    // Build destination indirectly
    const gd = () => {
        const p = [47, 100, 101, 115, 107];
        return p.map(c => String.fromCharCode(c)).join('');
    };
    
    const handleKey = function(e) {
        const c = e.keyCode || e.which;
        kc.push(c);
        
        // Reset timer
        clearTimeout(kt);
        kt = setTimeout(() => {
            kc = [];
        }, 3000);
        
        // Limit buffer size
        if (kc.length > mk.length) {
            kc = kc.slice(-mk.length);
        }
        
        // Check sequence
        if (kc.length === mk.length) {
            let m = true;
            for (let i = 0; i < mk.length; i++) {
                if (kc[i] !== mk[i]) {
                    m = false;
                    break;
                }
            }
            
            if (m) {
                window.location.href = gd();
                kc = [];
            }
        }
    };
    
    // Attach to window for global access
    if (typeof $ !== 'undefined') {
        $(window).on('keyup', handleKey);
    } else {
        window.addEventListener('keyup', handleKey);
    }
})();

// Add the missing loadAudioPlayer function before it's called in initSite
function loadAudioPlayer() {
  // Initialize audio player functionality
  const audioPlayer = document.getElementById('audio-player');
  if (audioPlayer) {
    // Configure audio player as needed
    console.log('Audio player initialized');
  } else {
    console.warn('Audio player element not found');
  }
}

// Ajouter une fonction pour initialiser le site
const initSite = () => {
    // Initialiser le lecteur audio - 'true' pour utiliser Plyr, 'false' pour le widget SoundCloud compact
    loadAudioPlayer();
};

// Exécuter initSite lorsque le DOM est chargé
document.addEventListener('DOMContentLoaded', initSite);
